module.exports = __webpack_public_path__ + "static/media/cy.aeaf869e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/countriesFlags/cy.svg
// module id = 1438
// module chunks = 0